import { __rest } from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import "./Dropdown.css";
import * as React from "react";
import { ExpandableButton } from '../../Button';
export function DropdownExpandableButton(props) {
    const { expandableRef, items, placeholder, renderSelectedItems, selection, tooltipProps } = props, rest = __rest(props, ["expandableRef", "items", "placeholder", "renderSelectedItems", "selection", "tooltipProps"]);
    let text = placeholder;
    if (selection.selectedCount > 0) {
        text = renderSelectedItems(selection, items);
    }
    return (React.createElement(ExpandableButton, Object.assign({ ref: expandableRef }, rest, { tooltipProps: Object.assign({ overflowOnly: true, overflowDetected }, props.tooltipProps) }),
        React.createElement("div", { className: "bolt-dropdown-expandable-button-label justify-start flex-grow text-ellipsis" },
            props.children,
            text)));
}
function overflowDetected(anchorElement) {
    const overflowElement = anchorElement.querySelector(".bolt-dropdown-expandable-button-label");
    if (overflowElement) {
        return overflowElement.scrollWidth > Math.ceil(overflowElement.offsetWidth);
    }
    return false;
}
